module.exports = __webpack_public_path__ + "img/temp-spiral-01.6505daf6.jpg";